module.exports = __webpack_public_path__ + "static/media/Logo__Nike.bbde70f1.svg";